// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__j99kL","content":"MainLayout_content__1QIok"};